import React, { useState } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Typography from '../../../../../UniformComponents/Typography'
import Button from '../../../../../UniformComponents/Button'
import analysingData from './analysingData.svg'
import './aiAssistant.scss'

// TODO later
// [ ] use data from endpoint
// [ ] build chat component (and hide it)

const AiSummaryNotReady = () => (
    <div className="not-ready">
        <img src={analysingData} alt="Analysing data" />
        <Typography type="p">{i18n.t('s_report_ai_summary_not_ready')}</Typography>
    </div>
)

const AiAssistant = observer(({ reportStore }) => {
    const [isSummaryExpanded, setIsSummaryExpanded] = useState(true)
    // const [isChatExpanded, setIsChatExpanded] = useState(false)

    const data = {
        lastRun: new Date(),
        lastNumOfResponses: 10,
        numOfResponses: 11,
        canRefresh: true,
        keyInsights: [
            {
                sentiment: 'positive',
                title: 'High satisfaction rate:',
                desc: '80% email responses indicate strong engagement, with an average satisfaction score of 4.38 out of 5.',
            },
            {
                sentiment: 'negative',
                title: 'Areas for improvement:',
                desc: '4 screening exits suggest potential optimization needed in survey flow.',
            },
        ],
        topFindings: 'Visitors show high overall satisfaction with networking opportunities and content quality. The "Very" satisfied category received 56.78% of responses, significantly outperforming industry benchmarks (3.88 vs 4.38 average).',
        recommendations: [
            'Continue focus on networking and content quality as key strengths',
            'Review screening questions to reduce early exits',
            'Leverage promoter verbatim feedback for marketing material',
        ],
    }
    // const data = reportStore.getAiSummary()

    const {
        showAiAssistant,
        toggleShowAiAssistant,
        copyAiSummary,
        refreshAiSummary,
        canTriggerAiRefresh,
    } = reportStore

    return (
        <div id="ai-assistant-container">
            <Button
                icon={`fal ${showAiAssistant ? 'fa-times' : 'fa-sparkles'}`}
                cssClass={`regular secondary ai-toggle-button ${showAiAssistant ? 'expanded' : ''}`}
                onClick={toggleShowAiAssistant}
            />

            <div className={`ai-panel ${showAiAssistant ? 'slide-in' : ''}`}>
                <div className="ai-panel-header">
                    <i className="fal fa-sparkles" />
                    <Typography type="h3">{i18n.t('s_report_ai_assistant')}</Typography>
                </div>

                <div className="ai-panel-content">
                    <div className="section-header">
                        <div className="section-title">
                            <i className="fal fa-sparkles" />
                            <Typography type="h4">{i18n.t('s_report_ai_summary')}</Typography>
                        </div>
                        <Button
                            icon={`fas fa-chevron-${isSummaryExpanded ? 'up' : 'down'}`}
                            onClick={() => setIsSummaryExpanded(!isSummaryExpanded)}
                            cssClass="icon-action-btn"
                        />
                    </div>

                    {isSummaryExpanded ? (
                        <div className="section-body">
                            <div className="section-item">
                                <div className="insights-header">
                                    <Typography type="b">{i18n.t('s_report_ai_key_insights')}</Typography>
                                    <div className="insights-actions">
                                        <Button
                                            title={canTriggerAiRefresh()
                                                ? i18n.t('s_report_ai_refresh')
                                                : i18n.t('s_report_ai_refresh_disabled')}
                                            icon="fas fa-refresh"
                                            onClick={refreshAiSummary}
                                            cssClass="icon-action-btn"
                                        />
                                        <Button
                                            title={i18n.t('copy')}
                                            icon="far fa-copy"
                                            onClick={copyAiSummary}
                                            cssClass="icon-action-btn"
                                        />
                                    </div>
                                </div>
                                <div className="insights-body">
                                    {data.keyInsights.map((insight, i) => (
                                        <div key={i} className={`insight-item ${insight.sentiment}`}>
                                            <div className="insight-icon">
                                                {insight.sentiment === 'positive' ? (
                                                    <i className="fas fa-smile" />
                                                ) : (
                                                    <i className="fas fa-frown" />
                                                )}
                                            </div>
                                            <div className="insight-content">
                                                <Typography type="b">{insight.title}</Typography>
                                                <Typography type="p">{insight.desc}</Typography>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="section-item">
                                <Typography type="b">{i18n.t('s_report_ai_top_findings')}</Typography>
                                <div className="findings-body">
                                    <Typography type="p">{data.topFindings}</Typography>
                                </div>
                            </div>

                            <div className="section-item">
                                <Typography type="b">{i18n.t('s_report_ai_recommendations')}</Typography>
                                <div className="recommendations-body">
                                    <ul>{data.recommendations.map((rec) => <li>{rec}</li>)}</ul>
                                </div>
                            </div>
                        </div>
                        // <AiSummaryNotReady />
                    ) : null}
                </div>
            </div>
        </div>
    )
})

export default AiAssistant
